import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    Output,
    Renderer2,
    ViewChild
} from "@angular/core";
import { ControlValueAccessor, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Button, ModalController } from "ionic-angular";
import { ListPickerControl } from "../list-picker-control.model";
import { ControlComponent } from "../../control.component";
import { ListPickerProviderService } from "./list-picker-provider.service";
import { IListProvider } from "./list-providers/list-provider.interface";
import { IListPickerControlModalComponentArgs } from "./modules/list-picker-control-modal/list-picker-control-modal";

@Component({
    selector: "listpicker",
    template: `
        <ion-item *ngIf="showDefaultListPicker">
            <ion-label
                ngClass="listpicker-value"
                item-content
            >
                {{displayValue}}
            </ion-label>
            <button
                ion-button
                item-end
                item-content
                ngClass="showListPicker"
                (click)="onShowListPicker()"
                (keydown.enter)="onShowListPicker()"
                #showListPickerButton
            >
                Pick
            </button>
            <button
                ion-button
                item-end
                item-content
                color="danger"
                (click)="onClear()"
            >
                <ion-icon name="remove"></ion-icon>
            </button>
        </ion-item>
        <ion-item *ngIf="showJobStatusPicker">
            <job-status-item
                [jobStatus]="value"
                [locked]="lockJobStatusPicker"
                item-content
                (changed)="onJobStatusChange($event)"
            ></job-status-item>
            <button
                ion-button
                item-right
                item-content
                color="danger"
                *ngIf="showJobStatusUndo"
                (click)="onJobStatusUndo()"
            >
                <ion-icon name="undo"></ion-icon>
            </button>
        </ion-item>
    `,
    providers: [

        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ListPickerControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => ListPickerControlComponent), multi: true}
    ],
    viewProviders: [
        ListPickerProviderService
    ]
})
export class ListPickerControlComponent extends ControlComponent implements ControlValueAccessor/*, OnChanges*/ {
    @Input("value") _value: string | Array<string>;
    @Input() definition: ListPickerControl;
    @Input() form: FormGroup;
    @Output() changes: EventEmitter<any> = new EventEmitter();
    @ViewChild("showListPickerButton") showListPickerButton: Button;

    listType: string;
    listProvider: IListProvider;

    protected originalValue: any;
    protected lockJobStatusPicker = false;

    constructor(
        protected elemRef: ElementRef,
        protected modalCtl: ModalController,
        protected controller: ListPickerProviderService,
        protected renderer: Renderer2
    ) {
        super(elemRef);
    }

    get displayValue(): string {
        return this.listProvider.getDisplayValue(this.value);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.listType = this.getOption("listType", "");
        this.listProvider = this.controller.getProvider(this.listType);
    }

    get showJobStatusPicker(): boolean {
        return this.definition && this.definition.name === "jobStatus";
    }

    get showDefaultListPicker(): boolean {
        return this.definition && this.definition.name !== "jobStatus";
    }

    get showJobStatusUndo(): boolean {
        return this.lockJobStatusPicker;
    }

    writeValue(value): void {
        this.originalValue = value;
        super.writeValue(value);
    }

    updateValue(value): void {
        super.updateValue(value);
    }

    onShowListPicker(): void {

        const modal = this.modalCtl.create("ListPickerControlModalComponent", {
            config: this.definition.config,
            initialValue: this.value
        } as IListPickerControlModalComponentArgs);

        modal.onDidDismiss(value => {

            if (value) {
                this.updateValue(value);
            }

            this.renderer.addClass(document.body, "focus-outline");
            setTimeout(() => {
                try {
                    this.showListPickerButton.getNativeElement().focus();
                } catch (e) {
                    console.warn(e);
                }
            }, 100);
        });

        modal.present();
    }

    onJobStatusChange(value: string): void {
        this.updateValue(value);
        this.lockJobStatusPicker = true;
    }

    onJobStatusUndo(): void {
        this.updateValue(this.originalValue);
        this.lockJobStatusPicker = false;
    }

    onClear(): void {
        this.updateValue("");
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-picker-control.component.ts